import type { ReactNode } from 'react';

/**
 * Two-column detail layout — contract point 2.
 *
 * Left: the body, in reading order. Right: the things you ACT on or CHECK —
 * ownership, related links, a request-access button. They were previously mixed
 * into the body, so "who owns this" sat wherever it happened to be rendered and
 * the reader had to hunt for it on every page.
 *
 * The rail is optional: `<DetailBody>` alone is a valid single-column page.
 */
export function DetailBody({ children, rail }: { children: ReactNode; rail?: ReactNode }) {
  if (!rail) return <div className="stack">{children}</div>;
  return (
    <div className="detail-grid">
      <div className="stack">{children}</div>
      <aside className="detail-rail stack-sm">{rail}</aside>
    </div>
  );
}

/** One labelled block in the rail. */
export function RailCard({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="rail-card">
      <h3 className="rail-card__title">{title}</h3>
      {children}
    </section>
  );
}
